export const CHANGE_PAGE = 'page/CHANGE_PAGE';
export const FETCH_SCHEMA_REQUEST = 'page/FETCH_SCHEMA_REQUEST';
export const FETCH_SCHEMA_FAILURE = 'page/FETCH_SCHEMA_FAILURE';
export const FETCH_SCHEMA_SUCCESS = 'page/FETCH_SCHEMA_SUCCESS';
export const FETCH_JANIS_CLIENT_SUCCESS = 'page/FETCH_JANIS_CLIENT_SUCCESS';
export const FETCH_JANIS_CLIENT_FAILURE = 'page/FETCH_JANIS_CLIENT_FAILURE';
export const SET_REMOTE_ACTIONS_CACHE = 'page/SET_REMOTE_ACTIONS_CACHE';
export const TOGGLE_MODAL_STATUS = 'page/TOGGLE_MODAL_STATUS';
export const LOAD_MODAL_INFO = 'page/LOAD_MODAL_INFO';
